import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: theme.palette.background.white,
        height: 'fit-content',
        width: '100%',
        borderRadius: 14,
        padding: theme.spacing(5, 7),
        paddingBottom: 0,
        position: 'relative',
    },
    innerContainer: {
        height: '100%',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '6px'
        },
        '&::-webkit-scrollbar-track': {
            background: 'none'
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.palette.background.darkGray
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: theme.palette.background.darkGray
        }
    },
    title: {
        marginBottom: theme.spacing(3),
    },
    buttonContainer: {
        padding: theme.spacing(4, 0),
    },
    button: {
        width: 'fit-content',
        height: 42
    },
    buttonPrimary: {
        backgroundColor: theme.palette.text.accent,
    },
    buttonSecondary: {
        color: theme.palette.text.accent,
        marginRight: theme.spacing(4),
    },
    deleteButton: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(2),
        backgroundColor: theme.palette.Primary.main,
        '&:hover': {
            backgroundColor: theme.palette.Primary.dark,
        }
    },
    topContainer: {
        maxWidth: 700,
    },
    bottomContainer: {
        maxWidth: 700,
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(15),
    },
    previewTitle: {
        marginBottom: theme.spacing(3)
    },
    previewItem: {
        margin: theme.spacing(1, 0),
        fontSize: 15
    },
    secondResultContainer: {
        paddingLeft: `${theme.spacing(4)} !important`,
        marginLeft: theme.spacing(4),
        borderLeft: `solid 1px ${theme.palette.Other.stroke}`,
    },
}));

export default useStyles;
